import Title from './title/title';

const Typography = {
  Title
};

export default Typography;
